function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.4615 2.44885C24.1727 -0.82149 18.9182 -0.82149 15.6294 2.44885L1.8381 16.4609C-0.655541 19.0526 -0.604651 23.2084 1.94624 25.7419C4.45896 28.2302 8.4666 28.2302 10.973 25.7419L23.4602 13.0548C25.0824 11.4067 25.0824 8.73099 23.4602 7.0829C21.8381 5.43481 19.2045 5.43481 17.5824 7.0829L5.63581 19.2206C5.22232 19.6601 5.22868 20.3581 5.66125 20.7782C6.0811 21.1919 6.74904 21.1919 7.16889 20.7782L19.1091 8.64697C19.8979 7.87786 21.1574 7.90372 21.9144 8.70514C22.6523 9.48718 22.6523 10.7152 21.9144 11.4972L9.43988 24.1843C7.75413 25.8712 5.03784 25.8518 3.37754 24.1391C1.72995 22.4457 1.72995 19.7183 3.37754 18.0185L17.1625 4.01292C19.618 1.51816 23.6002 1.51816 26.0557 4.01292C28.5111 6.50768 28.5111 10.5536 26.0557 13.0484L12.2707 27.0539C11.8127 27.4482 11.7618 28.1462 12.1498 28.6115C12.5378 29.0769 13.2249 29.1286 13.6829 28.7343C13.7274 28.6956 13.7656 28.6568 13.8037 28.6115L27.5887 14.606C30.8585 11.2128 30.8012 5.77089 27.4615 2.44885Z",
  fill: "#B7B5B5"
}));

function SvgStaple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaple);
export default __webpack_public_path__ + "static/media/staple.43da9f74.svg";
export { ForwardRef as ReactComponent };